import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserPanel from './UserPanel';
import { scrollToClass } from '../utils/scroll';
const Header = ({setIsLoggedIn, isLoggedIn, inProgress, setPoints, points}) => {
    const [isActivePanel, setIsActivePanel] = useState(false);
    const [initials,setInitials] = useState(``);
    const [referralCode, setReferralCode] = useState(``)
    const parseToken =(token) => {
        return JSON.parse(atob(token.split('.')[1]));
    }
    const navigate = useNavigate();



    const getInitialsAndCode = () => {
        let rawToken = localStorage.getItem(`jwt`);
        if(!rawToken) return
        const token = parseToken(rawToken);
        const nameChar = token.name.charAt(0);
        const surnameChar = token.surname.charAt(0);
        const {referralCode} = token
        setReferralCode(referralCode)
        setInitials(`${nameChar}${surnameChar}`)
    }


    // useEffect(() => {
    //     getInitialsAndCode();
    // },[])

    // useEffect(() => {
    //     if(!initials) return;
    //     setIsLoggedIn(true);
    // },[initials])

    // useEffect(() => {
    //     getInitialsAndCode()
    // },[isLoggedIn])





    return (
        <header>
        {/* <div className=''>
        
        </div> */}
        <div className="header-text-container">
                <h2 id="" onClick={() => navigate('/')}>Strona główna</h2>
            <h2 id='id="header-login"' onClick={() => {navigate("/produkty")}}>Cennik</h2>
            <h2 id="" onClick={() => navigate('/kontakt')}>Kontakt</h2>
            <h2 onClick={() => {navigate("/rezerwacja")}}>Zamów</h2>

            {/* {!isLoggedIn ?
            <h2 onClick={() => setIsActivePanel(true)} id="header-login">Zaloguj się</h2>
            :
            <div className="initials-container initialsJump">
            <h2 onClick={() => setIsActivePanel(true)} id="initials">{initials}</h2>
        </div> 
    
        }

        {
            isActivePanel ?
            <UserPanel referralCode={referralCode} setPoints={setPoints} points={points} parseToken={parseToken} inProgress={inProgress} isActivePanel={isActivePanel} setIsActivePanel={setIsActivePanel} isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}></UserPanel>
            : null

        } */}
        

        </div>
            <a  target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/profile.php?id=61573286314010">
                <img className="facebook-logo" src="Photos/facebook.webp" alt="Logo facebooka odnośnik do fanpage"></img>
            </a>

    </header>
    )
}


export default Header